import React from 'react';
import { motion } from 'framer-motion';
type RevealProps = {
  children: React.ReactNode;
  delay?: number;
  className?: string;
};
export function Reveal({
  children,
  delay = 0,
  className
}: RevealProps) {
  return <motion.div className={className} initial={{
    opacity: 0,
    y: 28,
    clipPath: 'inset(0 0 100% 0)'
  }} whileInView={{
    opacity: 1,
    y: 0,
    clipPath: 'inset(0 0 0% 0)'
  }} viewport={{
    once: true,
    margin: '-60px'
  }} transition={{
    duration: 0.8,
    delay,
    ease: [0.16, 1, 0.3, 1]
  }} data-id="element-46" data-mp="3binq6vuc68md">
      {children}
    </motion.div>;
}